import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@worldcoo/ui/components/accordion';
import { usePortalMetadataQuery } from '@/lib/queries';
import { useTranslation } from '@/lib/i18n';
import { isNotFound } from '@tanstack/react-router';
import { DivWithPrimaryColorVariable } from './div-with-primary-color-variable';

export function FaqSection() {
	const metadata = usePortalMetadataQuery();
	const { i18n } = useTranslation();

	if (isNotFound(metadata)) return null;

	const { faqItems } = metadata;
	if (!faqItems || faqItems.length === 0) return null;

	return (
		<div className="bg-secondary">
			<DivWithPrimaryColorVariable className="mx-auto flex max-w-[1366px] flex-col gap-8 px-6 py-16 lg:gap-12 lg:px-20 lg:py-24">
				<div className="flex flex-col gap-4">
					<h2 className="text-[32px] font-semibold tracking-tight lg:text-[40px]">{i18n.faq.title}</h2>
					<p className="text-sm font-medium lg:text-base">{i18n.faq.description}</p>
				</div>

				<Accordion type="single" collapsible className="flex flex-col gap-6">
					{faqItems.map((item) => (
						<AccordionItem
							key={item.question}
							value={item.question}
							className="rounded-2xl border-none bg-white p-6 shadow-[0px_4px_16px_0px_rgba(0,0,0,0.08)] lg:px-10 lg:py-8"
						>
							<AccordionTrigger
								className="py-0 text-lg font-semibold tracking-tight no-underline hover:no-underline lg:text-xl [&>svg]:size-6"
								style={{ color: 'var(--primary)' }}
							>
								{item.question}
							</AccordionTrigger>
							<AccordionContent className="pt-4 text-sm leading-relaxed lg:text-base">{item.answer}</AccordionContent>
						</AccordionItem>
					))}
				</Accordion>
			</DivWithPrimaryColorVariable>
		</div>
	);
}
